const projections: Record<string, { label: string; value: string }[]> = {
  hip_joint: [
    {
      label: "Выберите проекцию",
      value: "",
    },
    {
      label: "Аксиальная левый",
      value: "Ax_left",
    },
    {
      label: "Аксиальная правый",
      value: "Ax_right",
    },
    {
      label: "Аксиальная билатеральная",
      value: "Ax_bilateral",
    },
    {
      label: "Коронарная левый",
      value: "Cor_left",
    },
    {
      label: "Коронарная правый",
      value: "Cor_right",
    },
    {
      label: "Коронарная билатеральная",
      value: "Cor_bilateral",
    },
    {
      label: "Другое",
      value: "Other",
    },
  ],
  spine: [
    {
      label: "Выберите проекцию",
      value: "",
    },
    {
      label: "Коронарная",
      value: "Cor",
    },
    {
      label: "Сагиттальная",
      value: "Sag",
    },
  ],
};

export default projections;
